import { render } from "./ElectionVoteBODView.vue?vue&type=template&id=5c644474"
import script from "./ElectionVoteBODView.vue?vue&type=script&lang=js"
export * from "./ElectionVoteBODView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__